// 🔴 N°1001-C2 — une exception de RENDU dans le contenu métier ⛔ ne doit plus
// démonter TOUTE l'application (page blanche, menu compris — N°998-F : aucun
// ErrorBoundary n'existait dans le frontend). On isole le CONTENU : en-tête, menu et
// navigation restent utilisables ; l'utilisateur voit un message, peut Réessayer ou
// Revenir ; une trace nettoyée part en télémétrie (lib/telemetrieErreurs).
// 🔑 `key` = écran courant côté parent ⇒ changer d'écran réinitialise la barrière.
import React from "react";
import { signalerErreur } from "../lib/telemetrieErreurs";

export default class ErrorBoundaryContenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidCatch(erreur, info) {
    signalerErreur(erreur, { ecran: this.props.ecran, info, source: "boundary" });
  }

  render() {
    if (!this.state.erreur) return this.props.children;
    return (
      <div role="alert" data-testid="oh-erreur-contenu"
           style={{ background: "var(--oh-error-bg)", color: "var(--oh-error-text)",
                    border: "0.5px solid var(--oh-error-border)", borderRadius: 12,
                    padding: 16, display: "grid", gap: 12, maxWidth: 640 }}>
        <div style={{ fontWeight: 500 }}>Cet écran n'a pas pu s'afficher</div>
        <div style={{ lineHeight: 1.6 }}>
          Une erreur inattendue s'est produite. Vos données n'ont pas été modifiées.
          Vous pouvez réessayer ou revenir à l'écran précédent.
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button type="button" data-testid="oh-erreur-reessayer"
                  onClick={() => this.setState({ erreur: null })}
                  style={{ height: 36, padding: "0 16px", borderRadius: 8,
                           background: "var(--oh-accent-solid)", color: "var(--oh-accent-contrast)",
                           border: "0.5px solid var(--oh-accent-solid)" }}>
            Réessayer
          </button>
          {this.props.onRetour && (
            <button type="button" data-testid="oh-erreur-retour"
                    onClick={() => { this.setState({ erreur: null }); this.props.onRetour(); }}
                    style={{ height: 36, padding: "0 16px", borderRadius: 8, background: "transparent",
                             color: "var(--oh-text-secondary)", border: "0.5px solid var(--oh-border)" }}>
              Retour
            </button>
          )}
        </div>
      </div>
    );
  }
}
